// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const FIRESTORE_GENERAL_COLLECTION_MAP = {
  supervisionStaff: "supervisionStaff",
  incarcerationStaff: "incarcerationStaff",
  userUpdates: "userUpdates",
  clients: "clients",
  residents: "residents",
  clientUpdates: "clientUpdates",
  clientUpdatesV2: "clientUpdatesV2",
  clientOpportunityUpdates: "clientOpportunityUpdates",
  locations: "locations",
  milestonesMessages: "milestonesMessages",
  taskUpdates: "taskUpdates",
  usIdSupervisionTasks: "US_ID-supervisionTasks",
  usIdSupervisionTasksV2: "US_ID-supervisionTasksV2",
  usMoSupervisionTasks: "US_MO-supervisionTasks",
  usNdSupervisionTasks: "US_ND-supervisionTasks",
  usNeSupervisionTasks: "US_NE-supervisionTasks",
  usTxSupervisionTasks: "US_TX-supervisionTasks",
  clientFormUpdates: "clientFormUpdates",
  // Intentionally snake_case to match the storage convention agreed in the DAS-365 thread.
  customTasks: "custom_tasks",
} as const;

export type FirestoreCollectionName =
  keyof typeof FIRESTORE_GENERAL_COLLECTION_MAP;

export type FirestoreCollectionKey =
  | { key: FirestoreCollectionName; raw?: never }
  | { raw: string; key?: never };

export type FirestoreCollectionKeyConfig = {
  name: FirestoreCollectionKey;
  demo: boolean;
};

/**
 * Given a Firestore collection specifier and a demo flag,
 * returns the collection name that should be used in Firestore queries
 */
export function collectionNameFromConfig({
  name,
  demo,
}: FirestoreCollectionKeyConfig) {
  let collectionName = name.key
    ? FIRESTORE_GENERAL_COLLECTION_MAP[name.key]
    : name.raw;
  if (demo) collectionName = `DEMO_${collectionName}`;
  return collectionName;
}
